module.exports = __webpack_public_path__ + "img/pa.12be5e1d.svg";